// extracted by mini-css-extract-plugin
module.exports = {"comp-float-menu":"float-menu_comp-float-menu__4yngK","float-icon":"float-menu_float-icon__6cbaJ"};